const PRODUCT_MARKER = '[data-product-available]';
const ITEM_SELECTOR = [
  '.product-grid__item',
  '.resource-list__item',
  '.resource-list__slide',
  '.predictive-search-results__card--product',
  '.menu-drawer__featured-content-list-item--product',
  '.mega-menu__content-list-item',
].join(',');

/**
 * Assigns a stable visual order to every rendered product card.
 * Available products keep their original order (0); sold-out products
 * are moved after them (999). This also handles cards injected later by
 * infinite scroll, predictive search, and product recommendations.
 *
 * @param {ParentNode} root
 */
function moveSoldOutProductsLast(root = document) {
  const markers = [];

  if (root instanceof Element && root.matches(PRODUCT_MARKER)) markers.push(root);
  markers.push(...root.querySelectorAll(PRODUCT_MARKER));

  for (const marker of markers) {
    const item = marker.closest(ITEM_SELECTOR);
    if (!(item instanceof HTMLElement)) continue;

    const isAvailable = marker.dataset.productAvailable === 'true';
    item.style.order = isAvailable ? '0' : '999';
    item.dataset.productAvailabilityOrder = isAvailable ? 'available' : 'sold-out';
  }
}

moveSoldOutProductsLast();

let queued = false;
const observer = new MutationObserver((mutations) => {
  if (queued) return;
  if (!mutations.some((mutation) => mutation.addedNodes.length > 0)) return;

  queued = true;
  requestAnimationFrame(() => {
    moveSoldOutProductsLast();
    queued = false;
  });
});

observer.observe(document.documentElement, { childList: true, subtree: true });
